import { tenantHttp, type HttpClient, type QueryParams } from './core/http-client';
import type { Notification } from './models';

export class NotificationsService {
  constructor(private readonly http: HttpClient) {}

  list = (query: QueryParams) =>
    this.http.getPage<Notification>('/business/notifications', { query });

  unread = () => this.http.get<{ count: number }>('/business/notifications/unread-count');

  read = (id: string) => this.http.post(`/business/notifications/${id}/read`);

  readAll = () => this.http.post('/business/notifications/read-all');
}

export const notificationsService = new NotificationsService(tenantHttp);
